import { publicUrl } from 'modules/core/utils/routing';

export const STATIC_VIDEOS_URLS = {
  affordabilitySlider: publicUrl('/static/videos/affordability-slider_animation.mp4'),
  creditSlider: publicUrl('/static/videos/credit-slider_animation.mp4'),
  lengthSlider: publicUrl('/static/videos/loan-length-slider_animation.mp4'),
  loanValueSlider: publicUrl('/static/videos/loan-value-slider_animation.mp4'),
  learningVideo: 'https://static-media.streamline.auto/learning-links/Streamline_VersionA_720p_10mb.mp4',
};
